module.exports = __webpack_public_path__ + "img/криохирургическое_удаление_0.e6ce0966.png";